var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"logout-btn"},[_c('v-btn',{attrs:{"color":"purple","dark":"","round":""},on:{"click":_vm.logout}},[_c('span',{staticClass:"mr-2"},[_vm._v("Salir de la app")]),_c('v-icon',[_vm._v("exit_to_app")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }